// ══════════════════════════════════════════════════════════════════════════════════════════════
//  EL COMPLEMENTO NATIVO DEL BUSCA EN LA APP DE ANDROID (B-1946, 23-oct-2026, t419)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//  frontend/plugins/busca-alarma hace que el busca suene y vibre sin parar con el móvil bloqueado. Desde Android 14,
//  salir A PANTALLA COMPLETA encima de la pantalla bloqueada es un permiso («Notificaciones a pantalla completa») que
//  Google Play solo da de fábrica a las apps de llamadas y alarmas: en las demás lo enciende la persona. Esto pregunta
//  al complemento si lo tiene y abre ese ajuste. En el navegador, en el iPhone o en una app sin el complemento (o con
//  la versión 1, que no sabe contestarlo) no hace nada y no avisa de nada.
import { Capacitor, registerPlugin } from '@capacitor/core'

let _complemento = null

export function complementoBusca(cap = Capacitor) {
  try {
    if (!cap || cap.getPlatform() !== 'android') return null
    if (typeof cap.isPluginAvailable !== 'function' || !cap.isPluginAvailable('BuscaAlarma')) return null
  } catch { return null }
  if (!_complemento) _complemento = registerPlugin('BuscaAlarma')
  return _complemento
}

export async function estadoDelBuscaNativo(cap) {
  const p = complementoBusca(cap)
  if (!p || typeof p.estado !== 'function') return null
  try { return await p.estado() } catch { return null }
}

// Pura: la mide la guardia. Solo avisa si el teléfono dice que NO puede (si no se sabe, no se molesta a nadie).
export const faltaPantallaCompleta = (estado) => !!(estado && estado.pantallaCompleta === false)

export async function abrirAjustesPantallaCompleta(cap) {
  const p = complementoBusca(cap)
  if (!p || typeof p.abrirAjustesPantallaCompleta !== 'function') return false
  try { await p.abrirAjustesPantallaCompleta(); return true } catch { return false }
}
